/* Landing de Tienda (Konfirma Studio): galería, deslizadores, pestañas, barra de compra fija y carrito.
   Sin dependencias. Los deslizadores son cajas con desplazamiento nativo y anclaje: van con el dedo y el
   trackpad; para el ratón se les añade arrastre, y a la galería, flechas. */
(function () {
  'use strict';
  if (window.ltListo) return;
  window.ltListo = true;
  var d = document;
  var todos = function (sel, raiz) { return Array.prototype.slice.call((raiz || d).querySelectorAll(sel)); };
  var cada = function (fn) { var turno = 0; return function () { if (!turno) turno = requestAnimationFrame(function () { turno = 0; fn(); }); }; };

  /* Los hijos de una caja que se desliza y a cuál está más cerca. */
  function paradas(el) { return todos(':scope > *', el).map(function (h) { return h.offsetLeft - el.offsetLeft; }); }
  function irA(el, izquierda) {
    // Mientras se mueve sola, el anclaje se suelta: si no, el navegador lo corta a medio camino.
    el.classList.add('lt-moviendo');
    el.scrollTo({ left: Math.max(0, Math.min(izquierda, el.scrollWidth - el.clientWidth)), behavior: 'smooth' });
    clearTimeout(el.ltReloj);
    el.ltReloj = setTimeout(function () { el.classList.remove('lt-moviendo'); }, 520);
  }

  /* Arrastre con el ratón. Con el dedo o el trackpad la caja ya se desliza sola; con ratón no, y sin esto
     en un PC no habría forma de pasarla. Al soltar va a la parada siguiente, anterior o más cercana. */
  function arrastre(el) {
    if (el.ltArrastre) return;
    el.ltArrastre = true;
    var x0 = 0, s0 = 0, activo = false, movido = false;
    var medir = function () { if (el.scrollWidth - el.clientWidth > 4) el.setAttribute('data-lt-arrastra', ''); else el.removeAttribute('data-lt-arrastra'); };
    el.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse' || ev.button !== 0 || !el.hasAttribute('data-lt-arrastra')) return;
      activo = true; movido = false; x0 = ev.clientX; s0 = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (ev) {
      if (!activo) return;
      var dx = ev.clientX - x0;
      if (!movido && Math.abs(dx) < 6) return;
      if (!movido) { movido = true; clearTimeout(el.ltReloj); el.classList.add('lt-moviendo', 'lt-arrastrando'); }
      el.scrollLeft = s0 - dx;
    });
    var soltar = function (ev) {
      if (!activo) return;
      activo = false;
      if (!movido) return;
      el.classList.remove('lt-arrastrando');
      var dx = ev.clientX - x0;
      var p = paradas(el);
      var cerca = 0;
      p.forEach(function (x, k) { if (Math.abs(x - s0) < Math.abs(p[cerca] - s0)) cerca = k; });
      // Con un arrastre corto pero decidido basta para pasar a la de al lado.
      var destino = Math.abs(dx) > 40 ? cerca + (dx < 0 ? 1 : -1) : cerca;
      irA(el, p[Math.max(0, Math.min(destino, p.length - 1))]);
    };
    window.addEventListener('pointerup', soltar);
    window.addEventListener('pointercancel', soltar);
    // Si hubo arrastre, el clic con que termina no cuenta (no abre enlaces ni pulsa tarjetas).
    el.addEventListener('click', function (ev) { if (movido) { ev.preventDefault(); ev.stopPropagation(); movido = false; } }, true);
    el.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
    window.addEventListener('resize', cada(medir));
    window.addEventListener('load', medir);
    medir();
  }

  /* Galería: la tira grande, sus flechas y sus miniaturas. */
  function galeria(g) {
    if (g.ltListo) return;
    g.ltListo = true;
    var tira = g.querySelector('.lt-galeria__tira');
    var caja = g.querySelector('.lt-galeria__minis');
    var minis = todos('.lt-galeria__mini', g);
    if (!tira) return;
    arrastre(tira);
    // Flechas (se ven en pantallas con ratón): la tira va dentro de un marco para ponerlas encima.
    if (tira.children.length > 1) {
      var marco = d.createElement('div');
      marco.className = 'lt-galeria__marco';
      tira.parentNode.insertBefore(marco, tira);
      marco.appendChild(tira);
      [-1, 1].forEach(function (sentido) {
        var b = d.createElement('button');
        b.type = 'button';
        b.className = 'lt-galeria__flecha' + (sentido < 0 ? ' lt-galeria__flecha--atras' : '');
        b.setAttribute('aria-label', sentido < 0 ? 'Foto anterior' : 'Foto siguiente');
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
        b.addEventListener('click', function () {
          var total = tira.children.length;
          var i = Math.round(tira.scrollLeft / Math.max(1, tira.clientWidth)) + sentido;
          irA(tira, ((i + total) % total) * tira.clientWidth);
        });
        marco.appendChild(b);
      });
    }
    var marcar = function () {
      var i = Math.round(tira.scrollLeft / Math.max(1, tira.clientWidth));
      minis.forEach(function (m, k) { m.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      // La miniatura activa se trae a la vista sin mover la página.
      var m = minis[i];
      if (m && caja) {
        var a = m.offsetLeft - caja.offsetLeft;
        if (a < caja.scrollLeft || a + m.offsetWidth > caja.scrollLeft + caja.clientWidth) caja.scrollTo({ left: a - m.offsetWidth, behavior: 'smooth' });
      }
    };
    tira.addEventListener('scroll', cada(marcar), { passive: true });
    minis.forEach(function (m, k) { m.addEventListener('click', function () { irA(tira, k * tira.clientWidth); }); });
    marcar();
  }

  /* Deslizador con puntos: una rayita por elemento; se esconden si todo cabe. */
  function deslizador(el) {
    if (el.ltListo) return;
    el.ltListo = true;
    arrastre(el);
    var puntos = el.parentNode.querySelector('.lt-puntos');
    if (!puntos) return;
    var hijos = todos(':scope > *', el);
    puntos.innerHTML = '';
    var rayas = hijos.map(function (h) {
      var i = d.createElement('i');
      i.addEventListener('click', function () { irA(el, h.offsetLeft - el.offsetLeft); });
      puntos.appendChild(i);
      return i;
    });
    var marcar = function () {
      var cabe = el.scrollWidth - el.clientWidth < 4;
      puntos.style.display = cabe ? 'none' : '';
      var mejor = 0;
      hijos.forEach(function (h, k) { if (Math.abs(h.offsetLeft - el.offsetLeft - el.scrollLeft) < Math.abs(hijos[mejor].offsetLeft - el.offsetLeft - el.scrollLeft)) mejor = k; });
      if (el.scrollLeft >= el.scrollWidth - el.clientWidth - 4) mejor = hijos.length - 1;
      rayas.forEach(function (r, k) { r.setAttribute('aria-current', k === mejor ? 'true' : 'false'); });
    };
    el.addEventListener('scroll', cada(marcar), { passive: true });
    window.addEventListener('resize', cada(marcar));
    marcar();
  }

  /* Barra de compra fija: aparece cuando el botón principal ya quedó arriba. */
  function barra(b) {
    if (b.ltListo) return;
    b.ltListo = true;
    var ancla = d.querySelector('[data-lt-ancla]');
    if (!ancla) return;
    var revisar = cada(function () {
      if (ancla.getBoundingClientRect().bottom < 0) b.setAttribute('data-visible', ''); else b.removeAttribute('data-visible');
    });
    window.addEventListener('scroll', revisar, { passive: true });
    revisar();
  }

  function raiz() { return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/'; }

  d.addEventListener('click', function (ev) {
    var t = ev.target;
    var e;
    // Pestañas.
    if ((e = t.closest('.lt-pestana'))) {
      var grupo = e.closest('[data-lt-pestanas]');
      todos('.lt-pestana', grupo).forEach(function (p) {
        var activa = p === e;
        p.setAttribute('aria-selected', activa ? 'true' : 'false');
        var panel = d.getElementById(p.getAttribute('aria-controls'));
        if (panel) panel.hidden = !activa;
      });
      return;
    }
    // Opciones de compra (una por variante).
    if ((e = t.closest('.lt-opcion[data-variante]'))) {
      var compra = e.closest('.lt-compra');
      todos('.lt-opcion[data-variante]', compra).forEach(function (o) { o.setAttribute('aria-pressed', o === e ? 'true' : 'false'); });
      compra.setAttribute('data-variante', e.getAttribute('data-variante'));
      todos('[data-lt-precio]', compra).forEach(function (p) { p.textContent = e.getAttribute('data-precio'); });
      return;
    }
    // Añadir al carrito.
    if ((e = t.closest('[data-lt-anadir]'))) {
      ev.preventDefault();
      var c = e.closest('.lt-compra');
      var variante = c && c.getAttribute('data-variante');
      if (!variante || e.disabled) return;
      todos('[data-lt-anadir]', c).forEach(function (b) { b.disabled = true; });
      fetch(raiz() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('carrito'); return r.json(); })
        .then(function () { window.location.href = raiz() + 'cart'; })
        .catch(function () { todos('[data-lt-anadir]', c).forEach(function (b) { b.disabled = false; }); });
    }
  });

  /* Imágenes que no se piden al abrir: guardan su dirección en data-lt-src y se cargan cuando hace falta. */
  function cargar(img) {
    if (!img.getAttribute('data-lt-src')) return;
    if (img.getAttribute('data-lt-srcset')) img.srcset = img.getAttribute('data-lt-srcset');
    img.src = img.getAttribute('data-lt-src');
    img.removeAttribute('data-lt-src');
    img.removeAttribute('data-lt-srcset');
  }
  /* Las de más abajo en la página: al acercarse (a 400 px, también de lado: las de un deslizador). */
  var ojo = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      cargar(e.target);
      ojo.unobserve(e.target);
      // Si está en un deslizador, se traen de una vez sus hermanas: las que quedan a un lado no "se acercan" hasta
      // que se desliza, y llegarían tarde.
      var desl = e.target.closest('[data-lt-desl]');
      if (desl) todos('img[data-lt-src]', desl).forEach(function (img) { cargar(img); ojo.unobserve(img); });
    });
  }, { rootMargin: '400px 400px' }) : null;
  function diferidas(r) {
    todos('img[data-lt-diferida][data-lt-src]', r).forEach(function (img) { if (ojo) ojo.observe(img); else cargar(img); });
  }
  /* Las demás láminas de la galería: en cuanto el visitante la toca, la desliza o pulsa una flecha o una miniatura. */
  function restoDeGaleria(g) {
    var hecho = false;
    var traer = function () { if (hecho) return; hecho = true; todos('img[data-lt-galeria]', g).forEach(cargar); };
    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) { g.addEventListener(ev, traer, { passive: true, once: true }); });
    var tira = g.querySelector('.lt-galeria__tira');
    if (tira) tira.addEventListener('scroll', traer, { passive: true, once: true });
  }

  function arrancar(r) {
    todos('.lt-galeria', r).forEach(restoDeGaleria);
    diferidas(r);
    todos('.lt-galeria', r).forEach(galeria);
    todos('[data-lt-desl]', r).forEach(deslizador);
    todos('.lt-barra', r).forEach(barra);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { arrancar(); }); else arrancar();
  d.addEventListener('shopify:section:load', function (ev) { arrancar(ev.target); });
})();
